import React from "react";

//interfaces and enums
import { getImageAsset } from "../../../../helpers/Images";
import Icon from "../../icons/Icon";
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";



export interface IProfileImages {
    profileImageUrl?: string;
    className?: string;
    secondProfileImageUrl?: string;
    isSquareImage?: boolean;
    defaultSecondProfileImage?: boolean
}

const ProfileImage = ({profileImageUrl, className, secondProfileImageUrl, isSquareImage, defaultSecondProfileImage} :IProfileImages) => {   

    return (
        <div className={`tc-profile-image-wrapper ${className ?? ""} ${isSquareImage ? "square-image":""}`} aria-hidden="true">
            {profileImageUrl 
                ?   <img src={getImageAsset(30, profileImageUrl) } className={`profile-image`} alt=""/>
                :   <Icon className={"default-no-user-icon"} iconName={IconLibrary.USER_NONE} sizeInPx="14" color={"var(--thriveLightSlate)"}/>
            }

            {secondProfileImageUrl && <img src={getImageAsset(30, secondProfileImageUrl) } className={`second-profile-image`} alt=""/>}

            {defaultSecondProfileImage && <Icon className={"default-no-user-icon"} iconName={IconLibrary.USER_NONE} sizeInPx="14" color={"var(--thriveLightSlate)"}/>}
        </div>
    );
}

export default ProfileImage